// removed by extract-text-webpack-plugin
module.exports = {"dialog":"dialog-1eKeZ","description":"description-g5U9A"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lists/example/dialog-example/dialog-example.less
 ** module id = 173
 ** module chunks = 0
 **/